import styled, { createGlobalStyle, keyframes } from 'styled-components/macro';
import { palette } from './theme';

export const PBI_FILTER_ROW_HEIGHT = 49;
export const MACHINE_FILTER_SLIDER_WIDTH = 230;
export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: Rubik, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;

  }
  #root {
    height: 100%;
  }
  code {
      font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
`;
export const appearanceEffect = keyframes`
  0% {
     opacity: 0.01;
  }
  100% {
    opacity: 1;
  }
`;

export const NoDataIconWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const MobileDivider = styled.div`
  display: flex;
  height: 1px;
  width: 100%;
  background: #c5d0de;
`;
export const VerticalDevider = styled.div<{ color: string; height: string }>`
  display: flex;
  width: 1px;
  height: ${props => props.height};
  margin-left: 10px;
  background-color: ${props => props.color};
`;

export const buttonOnHoverColor = palette.primary.light;

// Legacy globalColors (deprecated - use theme.palette instead)
export const globalColors = {
  regular: {
    text: {
      primary: palette.text.primary,
      grey: palette.text.secondary,
      blue: palette.primary.main,
      red: palette.error.main,
      white: palette.primary.contrastText,
      yellow: '#d4a017',
      green: palette.success.main,
    },
    background: {
      grey: palette.background.default,
      blue: palette.primary.main,
      white: palette.background.paper,
      red: '#F10C00',
      yellow: palette.warning.main,
      green: palette.success.main,
      greyCardBackground: palette.grey[100],
      greyDivider: palette.grey[300],
      buttonBorder: palette.grey[300],
      cardBorder: palette.grey[200],
      disabled: palette.background.disabled,
      datePickerArrow: palette.text.primary,
    },
    buttons: {
      disableBorder: palette.grey[200],
      regularBorder: palette.text.primary,
      selectedBorder: palette.primary.main,
      whiteBorder: palette.primary.contrastText,
      disableText: palette.grey[200],
      regularText: palette.text.primary,
      selectedText: palette.primary.main,
      whiteText: palette.primary.contrastText,
      enabledIcon: palette.primary.main,
      disabledIcon: palette.grey[200],
    },
    arrows: {
      green: palette.success.main,
      red: palette.error.main,
      gray: palette.grey[300],
    },
  },
};

export const GraphTooltipContainer = styled.div<{ tooltipWidth: number }>`
  box-sizing: border-box;
  border: 5px solid white;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CardBorder = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #c5d0de;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  animation-name: ${appearanceEffect};
  animation-duration: 500ms;
`;
export const backgroundColors = {
  bg: '#4158d0',
  bgImg: 'linear-gradient(43deg, #4158d0 0%, #c850c0 46%, #ffcc70 100%)',
};
export const ScrollableContainer = styled.div`
  flex-grow: 1;
  display: flex;
  max-height: 100%;
  width: 100%;
  overflow: auto;
  @media (max-width: 380px) {
    padding: 0;
  }
  scrollbar-width: thin;
  scrollbar-color: #c1baba;

  &::-webkit-scrollbar {
    width: 9px;
  }
  &::-webkit-scrollbar-track {
    border-left: 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #c5d0de;
    border-radius: 13px;
  }
`;

// constants for responsive screens with no scroll but with scaling
// 1366x768 - 1920x1080 desktop range
// 1366x768
export const MIN_SCREEN_HEIGHT = 768;
export const MIN_SCREEN_WIDTH = 1366;
// 1920x1080
export const MAX_SCREEN_HEIGHT = 1080;
export const MAX_SCREEN_WIDTH = 1920;
// standard size for 1366*768
export const STANDARD_FONT_SIZE = 16;
// standard size for 1920*1080
export const MAX_FONT_SIZE = 20;
// standard height for 1366*768
export const LINE_HEIGHT_SMALL = 19;
// standard height for 1920*1080
export const LINE_HEIGHT_LARGE = 22;
// font weights
export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_BOLD = 700;

export const XMRColors = {
  green: '#1BB934',
  red: '#FF4081',
  yellow: '#FFAB2B',
};
